import { Permission } from '@today/types'
import { lazy, Suspense } from 'react'
import type { RouteObject } from 'react-router-dom'
import { RequirePermission } from '@/components/RequirePermission'

const AttributeMappingPage = lazy(async () => ({ default: (await import('./AttributeMapping')).AttributeMappingPage }))

/**
 * Identity & login → Attribute mapping (TO-377, identity-attribute-mapping-ui
 * REQ-201), lazy-loaded under either plane's SSO page and gated by
 * `tenant.manage_idp` — the server enforces it too.
 */
export const attributeMappingRoute = (path: string): RouteObject => ({
	path,
	element: (
		<RequirePermission permission={Permission.TENANT_MANAGE_IDP}>
			<Suspense fallback={<p className="p-6 text-ds-sm text-ds-text-muted">Loading attribute mapping…</p>}>
				<AttributeMappingPage />
			</Suspense>
		</RequirePermission>
	),
})
